// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__FacebookLike__facebookLike{border:none;overflow:hidden}", "",{"version":3,"sources":["webpack://./../common/modules-react/ml-components-platform-react/FacebookLike/FacebookLike.module.scss"],"names":[],"mappings":"AAAA,iCACI,WAAA,CACA,eAAA","sourcesContent":[".facebookLike {\n    border:none;\n    overflow:hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"facebookLike": "app__FacebookLike__facebookLike"
};
export default ___CSS_LOADER_EXPORT___;
